"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ramda = require("ramda");

var _propTypes = require("prop-types");

var _themePropType = _interopRequireDefault(require("../theme-prop-type"));

var _index = require("../index");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _background = _interopRequireDefault(require("../../components/background"));

var _excluded = ["maxWidth"],
    _excluded2 = ["as", "children", "containerProps", "htmlId", "maxWidth", "position", "px", "theme"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MaxContainer = (0, _styledComponents["default"])(function (_ref) {
  var maxWidth = _ref.maxWidth,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, props);
}).withConfig({
  displayName: "GridWrapper__MaxContainer",
  componentId: "sc-1i8qimh-0"
})(["max-width:", ";"], function (_ref2) {
  var maxWidth = _ref2.maxWidth;
  return maxWidth;
});
var propTypes = {
  as: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  children: _propTypes.node,
  containerProps: (0, _propTypes.objectOf)((0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number])),
  htmlId: _propTypes.string,
  maxWidth: _propTypes.number,
  position: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string]),
  px: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number]),
  theme: _themePropType["default"]
};

var GridWrapper = function GridWrapper(_ref3) {
  var _ref3$as = _ref3.as,
      as = _ref3$as === void 0 ? "section" : _ref3$as,
      children = _ref3.children,
      containerProps = _ref3.containerProps,
      htmlId = _ref3.htmlId,
      maxWidth = _ref3.maxWidth,
      _ref3$position = _ref3.position,
      position = _ref3$position === void 0 ? "relative" : _ref3$position,
      px = _ref3.px,
      theme = _ref3.theme,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded2);

  var computedProps = (0, _react.useMemo)(function () {
    var margins = (0, _ramda.pathOr)([], ["grid", "margins"], theme);
    var pxFixed = (0, _index.normalizeArray)(px, margins.length);
    var maxWidthVal = maxWidth || (0, _ramda.pathOr)([], ["grid", "maxWidth"], theme);
    var sidemargin = (0, _ramda.pathOr)(0, ["spacings", (0, _ramda.last)(margins)], theme);
    return Object.assign({
      maxWidth: maxWidthVal + 2 * sidemargin + "px",
      mx: "auto",
      px: px ? pxFixed : margins,
      width: 1
    }, containerProps);
  }, [containerProps, maxWidth, px, theme]);
  return /*#__PURE__*/_react["default"].createElement(_background["default"], _extends({
    forwardedAs: as,
    id: htmlId,
    position: position,
    width: 1
  }, props), /*#__PURE__*/_react["default"].createElement(MaxContainer, _extends({
    position: "relative"
  }, computedProps), children));
};

GridWrapper.propTypes = propTypes;

var _default = (0, _styledComponents.withTheme)(GridWrapper);

exports["default"] = _default;